export function getYears(startYear: number, reverse: boolean = true) {
  var currentYear = new Date().getFullYear();
  var years = [];
  startYear = startYear || 1980;

  while (startYear <= currentYear) {
    years.push(startYear++);
  }
  return reverse ? years.reverse() : years;
}

export function camelToSnake(s: string) {
  return s.replace(/[\w]([A-Z])/g, function(m) {
    return m[0] + "_" + m[1];
  }).toLowerCase();
}

/**
 * Rounds a number or string to a specified precision, with options for currency formatting and string output.
 *
 * @param number - The value to round. Can be a number or a string representing a number.
 * @param currency - If true, rounds to two decimal places (typical for currency values). Default is false.
 * @param override - Array[boolean, number] where the first element enables custom rounding precision, and the second element specifies the number of decimal places to round to. Default is [false, 1], meaning that no override is applied.
 * @param returnString - If true, returns the result as a string; otherwise, returns a number. Default is false. If returning as a string, the result will be formatted with commas for thousands separators.
 * @returns The rounded value, either as a number or a string, depending on `returnString`.
 */
export function dcRound(number: number | string, currency: boolean = false, override: [boolean, number] = [false, 1], returnString: boolean = false): string | number {
  //console.log("011524 number",number);
  //console.log("011524 number",number);
  let rounded: number | string;
  if (typeof number === 'number') {
    rounded = number;
  } else {
    rounded = parseFloat(number);
  }
  //console.log("011524 rounded", rounded);
  //console.log("X011524 rounded", rounded);
  //console.log("X011524 override", override);
  
  if (override[0]) {
    rounded = parseFloat(rounded.toFixed(0));
  } else if (currency) {
    if (returnString) {
      rounded = rounded.toFixed(2);
    } else {
      rounded = parseFloat(rounded.toFixed(2));
    }
  } else if (Math.abs(rounded) < 10) {
    rounded = parseFloat(rounded.toFixed(2));
  } else if (Math.abs(rounded) < 100) {
    rounded = parseFloat(rounded.toFixed(1));
  } else {
    if (returnString) {
      rounded = Math.round(rounded).toLocaleString(undefined, { maximumFractionDigits: 0 });
    } else {
      rounded = Math.round(rounded);
    }
  }

  if (returnString) {
    rounded = rounded.toString();
  }

  return rounded;
}

export function queryStringFromObject(params: Object, initialQuery: string = ''): string {
  const searchParams = new URLSearchParams(initialQuery);

  const entries = Object.entries(params);
  for (let i = 0; i < entries.length; i++) {
    const key = entries[i][0];
    const value = entries[i][1];
    if(value) {
      searchParams.append(key, value.toString());
    }
  }

  return searchParams.toString();
}

export function getBearerToken() {
  const token = localStorage.getItem('syncarto_jwt');
  return `Bearer ${token}`;
}

export function dev(arr: number[] | undefined): [number, number] {
  // Guard against undefined or empty arrays
  if (!arr || !Array.isArray(arr) || arr.length === 0) {
    return [0, 0]; // Return default values for mean and standard deviation
  }

  // Additional safety check - ensure all elements are numbers
  const validNumbers = arr.filter(function(n) { 
    return typeof n === 'number' && !isNaN(n);
  });
  if (validNumbers.length === 0) {
    return [0, 0];
  }

  // Creating the mean with Array.reduce
  let mean = validNumbers.reduce(function(acc, curr) {
    return acc + curr;
  }, 0) / validNumbers.length;

  // Assigning (value - mean) ^ 2 to every array item
  const squaredDifferences = validNumbers.map(function(k) {
    return Math.pow((k - mean), 2);
  });

  // Calculating the sum of updated array
  let sum = squaredDifferences.reduce(function(acc, curr) { 
    return acc + curr;
  }, 0);

  // Calculating the variance
  let variance = sum / validNumbers.length;

  // Returning the standard deviation
  return [mean, Math.sqrt(sum / validNumbers.length)];
}
